
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UnstyledCopyButton',
  data() {
    return {
      hasCopied: false
    }
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Copy'
    },
    successLabel: {
      type: String,
      default: 'Copied'
    },
    icon: {
      type: String,
      default: 'copy'
    },
    successIcon: {
      type: String,
      default: 'check'
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: 'base'
    },
    iconColor: {
      type: String,
      default: 'current'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    btnIcon(): string {
      return this.hasCopied ? this.successIcon : this.icon
    },

    btnLabel(): string | null {
      if (this.iconOnly) {
        return null
      }
      return this.hasCopied ? this.successLabel : this.label
    }
  },
  methods: {
    copyContent(): void {
      if (!this.disabled) {
        this.$copyToClipboard(this.value)
        this.hasCopied = true
        setTimeout(() => {
          this.hasCopied = false
        }, this.timeout)
      }
    }
  }
})
